import tmhRequest from '@/config/tmhRequest'


export default {

    createApplyStoreService: function (data) {
        return tmhRequest({
            url: '/apply/tmh/applystoreservice/createapplystoreservice',
            method: 'post',
            params: data,
        })
    },

}


// WEBPACK FOOTER //
// ./src/api/tmh/apply/applystoreservice.js